var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30.7251,
    width: 30,
    height: 30,
    rx: 5,
    transform: "rotate(-180 30 30.7251)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2323_6632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8011 19.5182C20.0535 19.2827 20.0671 18.8872 19.8316 18.6348L17.8963 16.5613L22.708 16.5613C23.0532 16.5613 23.333 16.2814 23.333 15.9363C23.333 15.5911 23.0532 15.3113 22.708 15.3113L17.8963 15.3113L19.8316 13.2377C20.0671 12.9854 20.0535 12.5899 19.8011 12.3544C19.5488 12.1189 19.1533 12.1324 18.9178 12.3849L16.0011 15.5099C15.777 15.7499 15.777 16.1226 16.0011 16.3627L18.9178 19.4877C19.1533 19.7401 19.5488 19.7537 19.8011 19.5182ZM10.1983 19.5182C9.94584 19.2827 9.93226 18.8872 10.1678 18.6348L12.1031 16.5613L7.29134 16.5613C6.94617 16.5613 6.66634 16.2814 6.66634 15.9363C6.66634 15.5911 6.94617 15.3113 7.29134 15.3113L12.1031 15.3113L10.1678 13.2377C9.93226 12.9854 9.94584 12.5899 10.1983 12.3544C10.4506 12.1189 10.8461 12.1324 11.0816 12.3849L13.9983 15.5099C14.2223 15.7499 14.2223 16.1226 13.9983 16.3627L11.0816 19.4877C10.8461 19.7401 10.4506 19.7537 10.1983 19.5182Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2323_6632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(25 25.7251) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.c832775115527c2310a58b0d88996043.svg";
export { ForwardRef as ReactComponent };